import { AES_GCM_ALGORITHM, AES_GCM_PARAMS, RSA_OAEP_PARAMS } from './constants';
import { arrayBufferToBase64, base64ToArrayBuffer, getWebCrypto } from './encoding';
import { importPrivateKey, importPublicKeyFromPem } from './rsa';

export async function generateDek(): Promise<CryptoKey> {
  const cryptoApi = getWebCrypto();

  return cryptoApi.subtle.generateKey(AES_GCM_ALGORITHM, true, ['encrypt', 'decrypt']);
}

export async function wrapDek(dek: CryptoKey, publicKeyPem: string): Promise<string> {
  const cryptoApi = getWebCrypto();
  const publicKey = await importPublicKeyFromPem(publicKeyPem);
  const rawDek = await cryptoApi.subtle.exportKey('raw', dek);
  const wrapped = await cryptoApi.subtle.encrypt(RSA_OAEP_PARAMS, publicKey, rawDek);

  return arrayBufferToBase64(wrapped);
}

export async function unwrapDek(
  wrappedDek: string,
  privateKey: CryptoKey | string,
): Promise<CryptoKey> {
  const cryptoApi = getWebCrypto();
  const key = await importPrivateKey(privateKey);
  const rawDek = await cryptoApi.subtle.decrypt(
    RSA_OAEP_PARAMS,
    key,
    base64ToArrayBuffer(wrappedDek),
  );

  return cryptoApi.subtle.importKey('raw', rawDek, AES_GCM_PARAMS, true, ['encrypt', 'decrypt']);
}
